import React from 'react';

export default function ErrorBoundary({ children, fallback }) {
  return <ErrorBoundaryClass fallback={fallback}>{children}</ErrorBoundaryClass>;
}

class ErrorBoundaryClass extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[LeadsZoneMap ErrorBoundary]', error, info);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '1.5rem',
            padding: '2rem',
            textAlign: 'center',
          }}
        >
          <div style={{ fontSize: '3rem' }}>⚠️</div>
          <h2 style={{ color: 'var(--accent)', fontSize: '1.4rem' }}>Algo inesperado aconteceu</h2>
          <p style={{ color: 'var(--text-secondary)', maxWidth: 480, fontSize: '0.9rem' }}>
            {this.state.error?.message || 'Erro interno da aplicação. Recarregue a página ou entre em contato com o suporte.'}
          </p>
          <button
            className="primary"
            onClick={() => window.location.reload()}
            style={{ padding: '10px 28px', fontSize: '0.9rem' }}
          >
            Recarregar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
